<template>
  <ais-current-refinements :transform-items="transformItems">
    <template #default="{ items, createURL }">
      <ul v-show="items.length > 0" class="active-filter-container">
        <template v-for="item in items">
          <li
            v-for="refinement in item.refinements"
            :key="
              [
                item.attribute,
                refinement.attribute,
                refinement.type,
                refinement.value,
                refinement.operator,
              ].join(':')
            "
            class="active-filter"
          >
            <span class="label">
              {{ refinement.label }}
            </span>
            <a
              :href="createURL(refinement)"
              class="remove"
              @click.prevent="item.refine(refinement)"
            >
              <IconClose class="white" />
            </a>
          </li>
        </template>
        <!-- Deliberatly don't remove ClearRefinementLink from the DOM, just hide it
             otherwise Algolia Instantsearch starts to do weird internal state changes -->
        <li
          :class="{
            'd-none': count === 0,
            'd-flex': count > 0,
            'align-items-center': true,
            'px-2': true,
            'mb-2': true,
          }"
        >
          <ClearRefinementLink :text="gettext('Verwijder alle filters')" />
        </li>
      </ul>
    </template>
  </ais-current-refinements>
</template>

<script>
import { AisCurrentRefinements } from 'vue-instantsearch';

import ClearRefinementLink from './ClearRefinementLink.vue';
import IconClose from '../../../../templates/icons/close.svg';

export default {
  components: {
    AisCurrentRefinements,
    ClearRefinementLink,
    IconClose,
  },
  data() {
    return {
      count: 0,
    };
  },
  methods: {
    transformItems(items) {
      let result = items
        .map(item => {
          // Remove section
          if (item.attribute === 'section_names') return false;
          // Remove categories
          if (item.attribute.indexOf('_categories.lvl') !== -1) return false;
          // Labels
          if (item.attribute === 'label_ids') {
            item.refinements.forEach(ref => {
              ref.label = this.$store.state.labels[ref.value];
            });
          }
          // Colors
          if (item.attribute === 'color') {
            item.refinements.forEach(ref => {
              ref.label = this.$store.getters.getColor(ref.value);
            });
          }
          // Material
          if (item.attribute === 'material_ids') {
            item.refinements.forEach(
              ref =>
                (ref.label = this.$store.getters.getMaterialName(ref.value))
            );
          }
          // Store location
          if (item.attribute === 'store_location') {
            item.refinements.forEach(
              ref => (ref.label = this.$store.getters.getCountryName(ref.value))
            );
          }
          // Giftcard
          if (item.attribute === 'fair_fashion_giftcard') {
            item.refinements.forEach(
              ref => (ref.label = this.gettext('Fair Fashion Giftcard'))
            );
          }
          // Sale
          if (item.attribute === 'discounted') {
            item.refinements.forEach(ref => (ref.label = this.gettext('Sale')));
          }
          // Price
          if (item.attribute === 'currency_prices.EUR.price') {
            item.refinements.forEach(
              ref =>
                (ref.label = `${ref.operator === '<=' ? '<' : '>'} €${
                  ref.value
                }`)
            );
          }
          return item;
        })
        .filter(item => !!item);
      this.count = result.length;
      return result;
    },
  },
};
</script>
